<template>
  <div class="uc-root">

    <div v-if="!loaded" class="uc-picker-wrap">

      <!-- Upload de novo arquivo -->
      <div class="uc-upload-area" :class="{ 'uc-upload-area--drag': dragOver, 'uc-upload-area--busy': uploading }"
        @dragover.prevent="dragOver = true" @dragleave.prevent="dragOver = false" @drop.prevent="onDrop"
        @click="!uploading && $refs.fileInput.click()">

        <input ref="fileInput" type="file" accept=".json,.csv" style="display:none" @change="onFileSelected" />

        <template v-if="!uploading">
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#00a884" stroke-width="1.8">
            <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          <p class="uc-upload-title">Clique para enviar ou arraste o arquivo aqui</p>
          <p class="uc-upload-sub">
            Arquivos <strong>.json</strong> ou <strong>.csv</strong> (separado por ponto e vírgula) &mdash; serão
            salvos em <code>/sftp/rio-branco/campanhas-whatsapp</code>
          </p>
        </template>
        <template v-else>
          <div class="uc-spin uc-spin--dark"></div>
          <span class="uc-upload-title">Enviando arquivo...</span>
        </template>
      </div>

      <!-- Arquivos já enviados -->
      <div class="uc-server-picker">
        <div class="uc-picker-header">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="3" width="20" height="14" rx="2" />
            <path d="M8 21h8M12 17v4" />
          </svg>
          <span>Arquivos já enviados em <code>/sftp/rio-branco/campanhas-whatsapp</code></span>
          <button class="uc-refresh-btn" @click="loadFileList" :disabled="loadingList" title="Atualizar lista">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              :class="{ 'uc-spin-icon': loadingList }">
              <polyline points="23 4 23 10 17 10" />
              <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" />
            </svg>
          </button>
        </div>

        <div v-if="loadingList" class="uc-file-loading">
          <div class="uc-spin"></div>
          <span>Buscando arquivos...</span>
        </div>
        <div v-else-if="fileListError" class="uc-file-error">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          {{ fileListError }}
        </div>
        <div v-else-if="!fileList.length" class="uc-file-empty">Nenhum arquivo enviado ainda.</div>
        <div v-else class="uc-file-list">
          <div v-for="file in fileList" :key="file.name" class="uc-file-item"
            :class="{ 'uc-file-item--active': selectedFile === file.name }" @click="selectedFile = file.name">
            <div class="uc-file-item__icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            </div>
            <div class="uc-file-item__info">
              <span class="uc-file-item__name">{{ file.name }}</span>
              <span class="uc-file-item__meta">{{ file.size }} &mdash; {{ file.modified }}</span>
            </div>
            <div v-if="selectedFile === file.name" class="uc-file-item__check">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3">
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </div>
          </div>
        </div>
        <button class="uc-load-btn" :disabled="!selectedFile || loadingSelected" @click="loadSelectedFile">
          <span v-if="!loadingSelected">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Carregar arquivo selecionado
          </span>
          <span v-else class="uc-spin-row">
            <div class="uc-spin"></div> Carregando...
          </span>
        </button>
      </div>
    </div>

    <!-- Estado carregado -->
    <div v-if="loaded && !hasError" class="uc-loaded-banner">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#25d366" stroke-width="2.5">
        <polyline points="20 6 9 17 4 12" />
      </svg>
      <div>
        <p class="uc-loaded-name">{{ fileName }}</p>
        <small>{{ totalProcessos }} processos &mdash; {{ totalSel }}/{{ limit }} envios selecionados</small>
      </div>
      <button class="uc-swap-btn" @click="clearFile">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="23 4 23 10 17 10" />
          <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" />
        </svg>
        Trocar
      </button>
    </div>

    <div v-if="hasError" class="uc-error-banner">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      {{ errorMsg }}
      <button class="uc-btn" style="margin-left:auto" @click="hasError = false; errorMsg = ''">Fechar</button>
    </div>

    <!-- Aviso de limite -->
    <div v-if="loaded && limit === 0" class="uc-limit-warn">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
      Limite diário atingido. Nenhum envio disponível no momento.
    </div>

    <!-- Toolbar -->
    <div v-if="loaded" class="uc-toolbar">
      <div class="uc-chips">
        <div class="uc-chip">
          <span class="uc-chip-lbl">Processos</span>
          <span class="uc-chip-val">{{ totalProcessos }}</span>
        </div>
        <div class="uc-chip">
          <span class="uc-chip-lbl">Envios selecionados</span>
          <span class="uc-chip-val" :style="{ color: totalSel >= limit ? '#7c6000' : '#0a5e2a' }">
            {{ totalSel }} / {{ limit }}
          </span>
        </div>
        <!-- Botão sem WhatsApp -->
        <button v-if="totalSemWpp > 0" class="uc-btn-semwpp" @click="semWppPage = 1; modalSemWpp = true">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="1" y1="1" x2="23" y2="23" />
            <path
              d="M16.72 11.06A10.94 10.94 0 0119 12.55M5 12.55a10.94 10.94 0 015.17-2.39M10.71 5.05A16 16 0 0122.56 9M1.42 9a15.91 15.91 0 014.7-2.88M8.53 16.11a6 6 0 016.95 0M12 20h.01" />
          </svg>
          {{ totalSemWpp }} sem WhatsApp
        </button>
        <!-- Botão LGPD -->
        <button v-if="totalBloqueados > 0" class="uc-btn-lgpd" @click="modalPage = 1; modalLgpd = true">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="12" />
            <line x1="12" y1="16" x2="12.01" y2="16" />
          </svg>
          {{ totalBloqueados }} sem autorização LGPD
        </button>
      </div>
      <div class="uc-actions">
        <button class="uc-btn" @click.stop="selAll" :disabled="limit === 0">Selecionar todos</button>
        <button class="uc-btn" @click.stop="deselAll">Limpar seleção</button>
      </div>
    </div>

    <!-- Lista paginada -->
    <template v-if="loaded">
      <div style="max-height:380px;overflow-y:auto;overflow-x:hidden;">
        <div class="uc-lista">
          <div v-for="proc in pageItems" :key="proc._idx" class="uc-proc"
            :class="{ 'uc-proc--bloqueado': proc.bloqueado }">

            <div class="uc-proc-head" @click="toggleOpen(proc._idx)">
              <div class="uc-proc-info">
                <span class="uc-proc-nome">
                  {{ proc.nome }}
                  <span v-if="proc.bloqueado" class="uc-lgpd-tag">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2.5">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    LGPD não autorizada
                  </span>
                </span>
                <span v-if="proc.cpf" class="uc-proc-cpd">
                  <span class="uc-proc-cpd__label">CPF/CNPJ</span>{{ proc.cpf }}
                </span>
              </div>
              <div class="uc-proc-meta">
                <span class="uc-badge" :class="proc.selCnt > 0 ? 'uc-badge--green' : 'uc-badge--grey'">
                  {{ proc.selCnt }}/{{ proc.tels.length }} tel.
                </span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#adb5bd" stroke-width="2"
                  :style="{ transform: proc.open ? 'rotate(180deg)' : '', transition: 'transform .2s' }">
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </div>
            </div>

            <div v-show="proc.open" class="uc-tels">
              <div v-for="(tel, ti) in proc.tels" :key="ti" class="uc-tel"
                :class="{ 'uc-tel--sel': tel.sel, 'uc-tel--bloqueado': tel.bloqueado, 'uc-tel--semwpp': tel.semWpp }"
                @click="!tel.bloqueado && !tel.semWpp && toggleTel(proc._idx, ti)">
                <div class="uc-chk" :class="{ 'uc-chk--on': tel.sel, 'uc-chk--blocked': tel.bloqueado || tel.semWpp }">
                  <svg v-if="tel.sel" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="white"
                    stroke-width="3.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  <svg v-else-if="tel.bloqueado || tel.semWpp" width="10" height="10" viewBox="0 0 24 24" fill="none"
                    stroke="white" stroke-width="3">
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </div>
                <span class="uc-tel-num">{{ tel.fmt }}</span>
                <span v-if="tel.dupCount > 1" class="uc-tel-dup">({{ tel.dupCount }}x)</span>
                <span v-if="tel.tipo" class="uc-tel-tipo">{{ tel.tipo }}</span>
                <span v-if="tel.bloqueado" class="uc-tel-lgpd">sem autorização</span>
                <span v-if="tel.semWpp" class="uc-tel-semwpp">sem WhatsApp</span>
              </div>
            </div>

          </div>
        </div>

        <div v-if="totalPages > 1" class="uc-pager">
          <button class="uc-pg-btn" :disabled="page === 1" @click="page = 1">&laquo;</button>
          <button class="uc-pg-btn" :disabled="page === 1" @click="page--">&lsaquo;</button>
          <span class="uc-pg-info">{{ page }} / {{ totalPages }}</span>
          <button class="uc-pg-btn" :disabled="page === totalPages" @click="page++">&rsaquo;</button>
          <button class="uc-pg-btn" :disabled="page === totalPages" @click="page = totalPages">&raquo;</button>
        </div>
      </div>
    </template>

    <!-- Modal Sem WhatsApp -->
    <div v-if="modalSemWpp" class="uc-modal-overlay" @click.self="modalSemWpp = false">
      <div class="uc-modal">
        <div class="uc-modal-head" style="background:#fff7ed;">
          <span class="uc-modal-title" style="color:#c2410c;">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#c2410c" stroke-width="2">
              <line x1="1" y1="1" x2="23" y2="23" />
              <path
                d="M16.72 11.06A10.94 10.94 0 0119 12.55M5 12.55a10.94 10.94 0 015.17-2.39M10.71 5.05A16 16 0 0122.56 9M1.42 9a15.91 15.91 0 014.7-2.88M8.53 16.11a6 6 0 016.95 0M12 20h.01" />
            </svg>
            Números sem WhatsApp ({{ semWppList.length }})
          </span>
          <button class="uc-modal-close" style="border-color:#fed7aa;color:#c2410c;" @click="modalSemWpp = false">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div class="uc-modal-body">
          <div v-for="(proc, i) in semWppPaginated" :key="i" class="uc-modal-item"
            style="border-color:#fed7aa;background:#fff7ed;">
            <div class="uc-modal-item__nome" style="color:#c2410c;">{{ proc.nome }}</div>
            <div class="uc-modal-item__info">
              <span v-if="proc.cpf" class="uc-proc-cpd" style="margin-top:0">
                <span class="uc-proc-cpd__label">CPF/CNPJ</span>{{ proc.cpf }}
              </span>
            </div>
            <div class="uc-modal-item__tels">
              <span v-for="(tel, ti) in proc.tels.filter(t => t.semWpp)" :key="ti"
                style="font-size:12px;font-family:monospace;background:#fed7aa;color:#c2410c;padding:2px 8px;border-radius:4px;font-weight:600;">
                {{ tel.fmt }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="semWppTotalPages > 1" class="uc-modal-pager">
          <button class="uc-pg-btn" :disabled="semWppPage === 1" @click="semWppPage = 1">&laquo;</button>
          <button class="uc-pg-btn" :disabled="semWppPage === 1" @click="semWppPage--">&lsaquo;</button>
          <span class="uc-pg-info">{{ semWppPage }} / {{ semWppTotalPages }}</span>
          <button class="uc-pg-btn" :disabled="semWppPage === semWppTotalPages" @click="semWppPage++">&rsaquo;</button>
          <button class="uc-pg-btn" :disabled="semWppPage === semWppTotalPages"
            @click="semWppPage = semWppTotalPages">&raquo;</button>
        </div>
      </div>
    </div>

    <!-- Modal LGPD -->
    <div v-if="modalLgpd" class="uc-modal-overlay" @click.self="modalLgpd = false">
      <div class="uc-modal">
        <div class="uc-modal-head">
          <span class="uc-modal-title">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#be123c" stroke-width="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            Clientes sem autorização LGPD ({{ bloqueadosList.length }})
          </span>
          <button class="uc-modal-close" @click="modalLgpd = false">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
        <div class="uc-modal-body">
          <div v-for="(proc, i) in bloqueadosPaginated" :key="i" class="uc-modal-item">
            <div class="uc-modal-item__nome">{{ proc.nome }}</div>
            <div class="uc-modal-item__info">
              <span v-if="proc.cpf" class="uc-proc-cpd" style="margin-top:0">
                <span class="uc-proc-cpd__label">CPF/CNPJ</span>{{ proc.cpf }}
              </span>
            </div>
            <div class="uc-modal-item__tels">
              <span v-for="(tel, ti) in proc.tels.filter(t => t.bloqueado)" :key="ti" class="uc-modal-tel">
                {{ tel.fmt }}
              </span>
            </div>
          </div>
        </div>
        <div v-if="bloqueadosTotalPages > 1" class="uc-modal-pager">
          <button class="uc-pg-btn" :disabled="modalPage === 1" @click="modalPage = 1">&laquo;</button>
          <button class="uc-pg-btn" :disabled="modalPage === 1" @click="modalPage--">&lsaquo;</button>
          <span class="uc-pg-info">{{ modalPage }} / {{ bloqueadosTotalPages }}</span>
          <button class="uc-pg-btn" :disabled="modalPage === bloqueadosTotalPages"
            @click="modalPage++">&rsaquo;</button>
          <button class="uc-pg-btn" :disabled="modalPage === bloqueadosTotalPages"
            @click="modalPage = bloqueadosTotalPages">&raquo;</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
var PAGE_SIZE = 100;
var UPLOAD_PATH = '/sftp/rio-branco/campanhas-whatsapp';

export default {
  props: {
    limit: { type: Number, default: 650 }
  },
  data() {
    return {
      dragOver: false,
      uploading: false,

      loadingList: false,
      fileListError: '',
      fileList: [],
      selectedFile: '',
      loadingSelected: false,

      loaded: false,
      fileName: '',
      hasError: false,
      errorMsg: '',
      totalProcessos: 0,
      totalSel: 0,
      totalBloqueados: 0,
      totalSemWpp: 0,
      page: 1,
      all: [],
      modalLgpd: false,
      modalSemWpp: false,
      modalPage: 1,
      modalPerPage: 10,
      semWppPage: 1,
      semWppPerPage: 10
    };
  },
  computed: {
    totalPages() { return Math.ceil(this.all.length / PAGE_SIZE) || 1; },
    pageItems() { var s = (this.page - 1) * PAGE_SIZE; return this.all.slice(s, s + PAGE_SIZE); },
    bloqueadosList() { return this.all.filter(function (p) { return p.bloqueado; }); },
    bloqueadosTotal() { return this.bloqueadosList.length; },
    bloqueadosTotalPages() { return Math.max(1, Math.ceil(this.bloqueadosTotal / this.modalPerPage)); },
    bloqueadosPaginated() { var s = (this.modalPage - 1) * this.modalPerPage; return this.bloqueadosList.slice(s, s + this.modalPerPage); },
    semWppList() {
      return this.all.filter(function (p) { return p.tels.some(function (t) { return t.semWpp; }); });
    },
    semWppTotalPages() { return Math.max(1, Math.ceil(this.semWppList.length / this.semWppPerPage)); },
    semWppPaginated() { var s = (this.semWppPage - 1) * this.semWppPerPage; return this.semWppList.slice(s, s + this.semWppPerPage); }
  },
  watch: {
    limit(newLimit) {
      if (!this.loaded) return;
      var cnt = 0;
      for (var i = 0; i < this.all.length; i++) {
        var sc = 0;
        for (var j = 0; j < this.all[i].tels.length; j++) {
          if (this.all[i].tels[j].bloqueado) continue;
          if (this.all[i].tels[j].semWpp) continue;
          var s = cnt < newLimit;
          this.$set(this.all[i].tels[j], 'sel', s);
          if (s) { sc++; cnt++; }
        }
        this.$set(this.all[i], 'selCnt', sc);
      }
      this.totalSel = cnt;
      this.emit();
    }
  },
  created() { this.loadFileList(); },
  methods: {
    // ---------- Lista de arquivos já enviados ----------
    loadFileList() {
      this.loadingList = true; this.fileListError = '';
      var self = this;
      axios.get('/marketing/campanha-arquivos')
        .then(function (res) { self.fileList = res.data || []; })
        .catch(function () { self.fileListError = 'Não foi possível listar os arquivos.'; })
        .finally(function () { self.loadingList = false; });
    },

    async loadSelectedFile() {
      if (!this.selectedFile) return;
      this.loadingSelected = true;
      this.hasError = false;
      var ext = (this.selectedFile.split('.').pop() || '').toLowerCase();
      var self = this;

      try {
        var res = await axios.get('/marketing/campanha-arquivo', { params: { file: this.selectedFile } });
        var raw = typeof res.data === 'string' ? res.data : JSON.stringify(res.data);
        // aqui self.selectedFile já é o nome exato do arquivo em disco
        // (veio da listagem real da pasta), então pode ser usado direto
        self.fileName = self.selectedFile;
        if (ext === 'csv') await self.parseCsv(raw);
        else await self.parse(raw);
      } catch (e) {
        self.setErr('Erro ao carregar o arquivo do servidor.');
      } finally {
        self.loadingSelected = false;
      }
    },

    // ---------- Upload de novo arquivo ----------
    onFileSelected(e) {
      var file = e.target.files && e.target.files[0];
      e.target.value = ''; // permite selecionar o mesmo arquivo novamente, se necessário
      if (file) this.processFile(file);
    },

    onDrop(e) {
      this.dragOver = false;
      var file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (file) this.processFile(file);
    },

    async processFile(file) {
      var ext = (file.name.split('.').pop() || '').toLowerCase();
      if (['json', 'csv'].indexOf(ext) === -1) {
        this.setErr('Formato não suportado. Envie um arquivo .json ou .csv.');
        return;
      }

      this.uploading = true;
      this.hasError = false;

      // Nome que o servidor efetivamente salvou em disco. O backend
      // sanitiza o nome original (troca espaços/acentos/símbolos por "_"),
      // então NÃO podemos assumir que é igual a file.name — precisamos do
      // nome de volta na resposta do upload para tudo que vier depois
      // (parse, exibição e principalmente o "fileName" enviado com a
      // campanha, usado para mover o arquivo para _old).
      var savedFileName = file.name;

      try {
        var uploadRes = await this.uploadToServer(file);
        if (uploadRes && uploadRes.data && uploadRes.data.file) {
          savedFileName = uploadRes.data.file;
        }
      } catch (err) {
        var status = err && err.response && err.response.status;
        var msg = status === 409
          ? ((err.response.data && err.response.data.error) || 'Esse arquivo já foi enviado anteriormente. Selecione-o na lista para utilizá-lo.')
          : 'Não foi possível enviar o arquivo para o servidor.';
        this.setErr(msg);
        return;
      }

      // arquivo salvo no servidor: atualiza a lista para exibi-lo
      this.loadFileList();

      var raw;
      try {
        raw = await this.readFileAsText(file);
      } catch (e) {
        this.uploading = false;
        this.setErr('Arquivo enviado, mas não foi possível lê-lo. Selecione-o na lista para tentar novamente.');
        return;
      }

      this.fileName = savedFileName;
      this.uploading = false;

      try {
        if (ext === 'csv') await this.parseCsv(raw);
        else await this.parse(raw);
      } catch (e) {
        this.setErr('Não foi possível processar o arquivo.');
      }
    },

    uploadToServer(file) {
      var formData = new FormData();
      formData.append('file', file);
      formData.append('destino', UPLOAD_PATH);
      return axios.post('/marketing/campanha-upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
    },

    readFileAsText(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () { resolve(String(reader.result || '')); };
        reader.onerror = function () { reject(new Error('read failed')); };
        reader.readAsText(file, 'UTF-8');
      });
    },

    // ---------- Parse JSON (formato original) ----------
    async parse(raw) {
      var data;
      try { data = JSON.parse(raw); } catch (e) { this.setErr('JSON inválido.'); return; }
      var src = Array.isArray(data) ? data : (data.processos || data.data || null);
      if (!src || !Array.isArray(src)) { this.setErr('"processos" não encontrado.'); return; }

      var self = this, items = [], cnt = 0, lim = this.limit;
      var todosNorms = [];

      src.forEach(function (proc) {
        var dev = proc.devedor || proc;
        if (!dev) return;
        var rawTels = dev.telefones || [];
        if (!rawTels.length) return;

        var tels = [], seen = {};
        rawTels.forEach(function (t) {
          var n = String(t.numero || '').replace(/\D/g, '');
          if (!n) return;
          var ddd = String(t.ddd || '').replace(/\D/g, '');
          if (ddd && n.indexOf(ddd) === 0) { var sem = n.slice(ddd.length); if (sem.length >= 7 && sem.length <= 9) n = sem; }
          var local = (ddd + n).replace(/\D/g, '');
          var valid = (local.length === 11 && local[2] === '9') || local.length === 10;
          if (!valid || local.length < 10) return;
          if (seen[local] !== undefined) { tels[seen[local]].dupCount++; return; }
          seen[local] = tels.length;
          var fmt = '(' + ddd + ') ' + self.fmtN(n);
          var norm = '55' + local;
          var sel = cnt < lim; if (sel) cnt++;
          tels.push({ norm: norm, fmt: fmt, tipo: t.tipo || t.nomeContato || '', dupCount: 1, sel: sel, bloqueado: false, semWpp: false });
          todosNorms.push(norm);
        });
        if (!tels.length) return;

        var cpf = dev.codCategoria === 'F' ? self.maskCpf(dev.cnpjCpf || '') : (dev.cnpjCpf || '');
        items.push({
          _idx: items.length, nome: dev.nome || '', cpf: cpf,
          linkPagamento: dev.linkPagamento || proc.linkPagamento || proc.link_pagamento || '',
          titulos: proc.titulos || [], telefonesRaw: dev.telefones || [],
          open: false, selCnt: tels.filter(function (t) { return t.sel; }).length,
          tels: tels, bloqueado: false
        });
      });

      if (!items.length) { this.setErr('Nenhum processo com telefone válido.'); return; }

      this.all = items;
      this.totalProcessos = items.length;
      this.totalSel = Math.min(cnt, lim);
      this.page = 1;
      this.loaded = true;

      await this.checkLgpd(todosNorms);
      // await this.checkWpp(todosNorms);

      this.emit();
    },

    // ---------- Parse CSV (novo formato, separado por ;) ----------
    // Nome;Telefone;CPF/CNPJ/ID;Grupo;Fila;Consultor;Nome da Empresa;E-mail;Departamento;Divisão;Status
    async parseCsv(raw) {
      var lines = raw.split(/\r\n|\n|\r/).filter(function (l) { return l.trim() !== ''; });
      if (lines.length < 2) { this.setErr('Arquivo CSV vazio ou sem dados.'); return; }

      // remove o cabeçalho (linha 0)
      var self = this, cnt = 0, lim = this.limit, todosNorms = [];
      var grupos = {}, ordem = [];

      for (var i = 1; i < lines.length; i++) {
        var cols = lines[i].split(';');
        var nome = (cols[0] || '').trim();
        var telefoneRaw = (cols[1] || '').trim();
        var cpfRaw = (cols[2] || '').trim();
        var grupoRaw = (cols[3] || '').trim();
        var filaRaw = (cols[4] || '').trim();
        var consultorRaw = (cols[5] || '').trim();
        var empresaRaw = (cols[6] || '').trim();
        var emailRaw = (cols[7] || '').trim();
        var departamentoRaw = (cols[8] || '').trim();
        var divisaoRaw = (cols[9] || '').trim();
        var statusRaw = (cols[10] || '').trim();
        if (!nome && !telefoneRaw) continue;

        var digits = telefoneRaw.replace(/\D/g, '');
        if (digits.length >= 12 && digits.slice(0, 2) === '55') digits = digits.slice(2);
        var local = digits;
        var valid = (local.length === 11 && local[2] === '9') || local.length === 10;
        if (!valid) continue;

        var ddd = local.slice(0, 2);
        var numPart = local.slice(2);
        var fmt = '(' + ddd + ') ' + self.fmtN(numPart);
        var norm = '55' + local;

        var key = (cpfRaw || nome).trim().toLowerCase();
        if (!grupos[key]) {
          var cpf = cpfRaw.replace(/\D/g, '').length === 11 ? self.maskCpf(cpfRaw) : cpfRaw;
          grupos[key] = {
            _idx: ordem.length, nome: nome, cpf: cpf,
            linkPagamento: '', titulos: [], telefonesRaw: [],
            // Atributos do cliente vindos do CSV (não do telefone individual),
            // por isso ficam no "processo"/grupo, não em cada tel.
            grupo: grupoRaw, fila: filaRaw, consultor: consultorRaw,
            empresa: empresaRaw, email: emailRaw, departamento: departamentoRaw,
            divisao: divisaoRaw, statusContato: statusRaw,
            open: false, selCnt: 0, tels: [], bloqueado: false, _seen: {}
          };
          ordem.push(key);
        }

        var proc = grupos[key];
        if (proc._seen[norm] !== undefined) {
          proc.tels[proc._seen[norm]].dupCount++;
          continue;
        }
        var sel = cnt < lim; if (sel) cnt++;
        proc._seen[norm] = proc.tels.length;
        proc.tels.push({ norm: norm, fmt: fmt, tipo: '', dupCount: 1, sel: sel, bloqueado: false, semWpp: false });
        proc.telefonesRaw.push({ numero: numPart, ddd: ddd });
        if (sel) proc.selCnt++;
        todosNorms.push(norm);
      }

      var items = ordem.map(function (key, idx) {
        var p = grupos[key];
        p._idx = idx;
        delete p._seen;
        return p;
      });

      if (!items.length) { this.setErr('Nenhum contato com telefone válido encontrado no CSV.'); return; }

      this.all = items;
      this.totalProcessos = items.length;
      this.totalSel = Math.min(cnt, lim);
      this.page = 1;
      this.loaded = true;

      await this.checkLgpd(todosNorms);
      // await this.checkWpp(todosNorms);

      this.emit();
    },

    async checkLgpd(phones) {
      if (!phones.length) return;
      try {
        var res = await axios.post('/marketing/check-permission', { phones: phones });
        var bloqueados = res.data || [];
        if (!bloqueados.length) return;
        var self = this, totalB = 0;
        this.all.forEach(function (proc, pi) {
          var procBloqueado = false;
          proc.tels.forEach(function (tel, ti) {
            var sufNorm = tel.norm.slice(-10);
            var isBloqueado = bloqueados.some(function (b) {
              return String(b).replace(/\D/g, '').slice(-10) === sufNorm;
            });
            if (isBloqueado) {
              self.$set(self.all[pi].tels[ti], 'bloqueado', true);
              self.$set(self.all[pi].tels[ti], 'sel', false);
              procBloqueado = true; totalB++;
            }
          });
          if (procBloqueado) {
            self.$set(self.all[pi], 'bloqueado', true);
            self.$set(self.all[pi], 'selCnt', proc.tels.filter(function (t) { return t.sel; }).length);
          }
        });
        var cnt = 0;
        this.all.forEach(function (p) { p.tels.forEach(function (t) { if (t.sel) cnt++; }); });
        this.totalSel = cnt;
        this.totalBloqueados = totalB;
      } catch (e) { console.warn('Erro ao verificar LGPD:', e); }
    },

    toggleOpen(idx) { this.$set(this.all[idx], 'open', !this.all[idx].open); },

    toggleTel(idx, ti) {
      var proc = this.all[idx], tel = proc.tels[ti];
      if (tel.bloqueado || tel.semWpp) return;
      if (!tel.sel && this.totalSel >= this.limit) return;
      var newSel = !tel.sel;
      this.$set(proc.tels[ti], 'sel', newSel);
      this.$set(this.all[idx], 'selCnt', proc.tels.filter(function (t, i) { return i === ti ? newSel : t.sel; }).length);
      this.totalSel += newSel ? 1 : -1;
      this.emit();
    },

    selAll() {
      var cnt = 0;
      for (var i = 0; i < this.all.length; i++) {
        var sc = 0;
        for (var j = 0; j < this.all[i].tels.length; j++) {
          if (this.all[i].tels[j].bloqueado || this.all[i].tels[j].semWpp) continue;
          var s = cnt < this.limit;
          this.$set(this.all[i].tels[j], 'sel', s);
          if (s) { sc++; cnt++; }
        }
        this.$set(this.all[i], 'selCnt', sc);
      }
      this.totalSel = cnt; this.emit();
    },

    deselAll() {
      for (var i = 0; i < this.all.length; i++) {
        for (var j = 0; j < this.all[i].tels.length; j++) {
          if (!this.all[i].tels[j].bloqueado && !this.all[i].tels[j].semWpp)
            this.$set(this.all[i].tels[j], 'sel', false);
        }
        this.$set(this.all[i], 'selCnt', 0);
      }
      this.totalSel = 0; this.emit();
    },

    emit() {
      var out = [], fileName = this.fileName;
      this.all.forEach(function (p) {
        p.tels.forEach(function (t) {
          if (!t.sel || t.bloqueado || t.semWpp) return;
          out.push({
            nome: p.nome, cpfCnpj: p.cpf, telefone: t.norm, phone: t.norm,
            linkPagamento: p.linkPagamento, titulos: p.titulos, telefones: p.telefonesRaw,
            // Campos extras do CSV (Grupo;Fila;Consultor;Nome da Empresa;E-mail;Departamento;Divisão;Status)
            grupo: p.grupo || '', fila: p.fila || '', consultor: p.consultor || '',
            empresa: p.empresa || '', email: p.email || '', departamento: p.departamento || '',
            divisao: p.divisao || '', statusContato: p.statusContato || ''
          });
        });
      });
      this.$emit('contacts-loaded', { contacts: out, fileName: fileName });
    },

    fmtN(n) { if (n.length === 9) return n.slice(0, 5) + '-' + n.slice(5); if (n.length === 8) return n.slice(0, 4) + '-' + n.slice(4); return n; },
    maskCpf(c) { var d = String(c).replace(/\D/g, ''); if (d.length !== 11) return c; return '***.***.' + d.slice(6, 9) + '-' + d.slice(9); },
    setErr(m) { this.uploading = false; this.loadingSelected = false; this.hasError = true; this.errorMsg = m; },
    reset() {
      this.hasError = false; this.errorMsg = ''; this.loaded = false;
      this.uploading = false; this.loadingSelected = false; this.selectedFile = '';
      this.totalSel = 0; this.totalProcessos = 0; this.totalBloqueados = 0; this.totalSemWpp = 0;
      this.page = 1; this.all = []; this.fileName = '';
      this.modalLgpd = false; this.modalPage = 1;
      this.modalSemWpp = false; this.semWppPage = 1;
      this.loadFileList();
      this.$emit('contacts-cleared');
    },
    clearFile() { this.reset(); }
  }
};
</script>

<style scoped>
.uc-root {
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.uc-picker-wrap {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.uc-upload-area {
  border: 2px dashed #d1d7db;
  border-radius: 10px;
  background: #fafbfc;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  text-align: center;
  cursor: pointer;
  transition: border-color .15s, background .15s;
}

.uc-upload-area:hover {
  border-color: #00a884;
  background: #f6fffb;
}

.uc-upload-area--drag {
  border-color: #25d366;
  background: #f0fdf4;
}

.uc-upload-area--busy {
  cursor: default;
}

.uc-upload-title {
  margin: 4px 0 0;
  font-size: 13.5px;
  font-weight: 600;
  color: #111b21;
}

.uc-upload-sub {
  margin: 0;
  font-size: 12px;
  color: #667781;
  max-width: 380px;
  line-height: 1.5;
}

.uc-upload-sub code,
.uc-picker-header code {
  background: #e9edef;
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 11px;
  color: #111b21;
}

.uc-server-picker {
  border: 1px solid #e9edef;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

.uc-picker-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9edef;
  font-size: 12px;
  color: #667781;
}

.uc-refresh-btn {
  margin-left: auto;
  width: 26px;
  height: 26px;
  border: 1px solid #e9edef;
  border-radius: 6px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #667781;
  flex-shrink: 0;
}

.uc-refresh-btn:hover:not(:disabled) {
  border-color: #00a884;
  color: #00a884;
}

.uc-spin-icon {
  animation: sp .7s linear infinite;
}

.uc-file-loading {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 14px;
  font-size: 13px;
  color: #667781;
}

.uc-file-error {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 14px;
  font-size: 13px;
  color: #c62828;
  background: #fff1f0;
}

.uc-file-empty {
  padding: 16px 14px;
  font-size: 13px;
  color: #adb5bd;
  text-align: center;
}

.uc-file-list {
  max-height: 200px;
  overflow-y: auto;
}

.uc-file-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 1px solid #f0f2f5;
  transition: background .1s;
}

.uc-file-item:last-child {
  border-bottom: none;
}

.uc-file-item:hover {
  background: #f8f9fa;
}

.uc-file-item--active {
  background: #f0fdf4;
}

.uc-file-item__icon {
  color: #adb5bd;
  flex-shrink: 0;
}

.uc-file-item--active .uc-file-item__icon {
  color: #00a884;
}

.uc-file-item__info {
  flex: 1;
  min-width: 0;
}

.uc-file-item__name {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #111b21;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.uc-file-item__meta {
  display: block;
  font-size: 11px;
  color: #adb5bd;
  margin-top: 1px;
}

.uc-file-item__check {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #25d366;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.uc-load-btn {
  width: 100%;
  padding: 10px;
  border: none;
  border-top: 1px solid #e9edef;
  background: #25d366;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  transition: background .15s;
}

.uc-load-btn:hover:not(:disabled) {
  background: #20bc5a;
}

.uc-load-btn:disabled {
  background: #c8e6c9;
  cursor: not-allowed;
}

.uc-spin-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.uc-loaded-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  background: #f6ffed;
  border: 1px solid #25d366;
  border-radius: 10px;
}

.uc-loaded-name {
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0a5e2a;
}

.uc-loaded-banner small {
  font-size: 11px;
  color: #667781;
}

.uc-error-banner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #fff1f0;
  border: 1px solid #fde8e8;
  border-radius: 10px;
  font-size: 13px;
  color: #c62828;
}

.uc-limit-warn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  background: #fff7e6;
  border: 1px solid #ffd591;
  border-radius: 10px;
  font-size: 13px;
  color: #b45309;
}

.uc-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
}

.uc-chips {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
}

.uc-chip {
  background: #f8f9fa;
  border: 1px solid #e9edef;
  border-radius: 8px;
  padding: 6px 12px;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.uc-chip-lbl {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: #adb5bd;
}

.uc-chip-val {
  font-size: 15px;
  font-weight: 600;
  color: #111b21;
}

.uc-actions {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.uc-btn-semwpp {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  background: #fff7ed;
  border: 1.5px solid #fed7aa;
  color: #c2410c;
  transition: background .15s;
}

.uc-btn-semwpp:hover {
  background: #ffedd5;
}

.uc-btn-lgpd {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  background: #fff1f2;
  border: 1.5px solid #fecdd3;
  color: #be123c;
  transition: background .15s;
}

.uc-btn-lgpd:hover {
  background: #ffe4e6;
}

.uc-btn {
  font-size: 12px;
  font-weight: 500;
  padding: 5px 11px;
  border-radius: 6px;
  cursor: pointer;
  border: 1px solid #e9edef;
  background: none;
  color: #667781;
}

.uc-btn:hover:not(:disabled) {
  border-color: #00a884;
  color: #00a884;
}

.uc-btn:disabled {
  opacity: .4;
  cursor: not-allowed;
}

.uc-lista {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.uc-proc {
  border: 1px solid #e9edef;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
}

.uc-proc--bloqueado {
  border-color: #fecdd3 !important;
  background: #fff8f8 !important;
}

.uc-proc-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  cursor: pointer;
  user-select: none;
}

.uc-proc-head:hover {
  background: #f8f9fa;
}

.uc-proc--bloqueado .uc-proc-head:hover {
  background: #fff1f2;
}

.uc-proc-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.uc-proc-nome {
  font-size: 13px;
  font-weight: 600;
  color: #111b21;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: center;
  gap: 6px;
}

.uc-proc--bloqueado .uc-proc-nome {
  color: #be123c;
}

.uc-lgpd-tag {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 10px;
  font-weight: 700;
  color: #be123c;
  background: #ffe4e6;
  border-radius: 4px;
  padding: 1px 6px;
  white-space: nowrap;
  flex-shrink: 0;
}

.uc-proc-cpd {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 1px;
  font-size: 11px;
  color: #000;
  background: #88acff;
  border-radius: 5px;
  padding: 1px 7px 1px 5px;
  width: fit-content;
  font-family: monospace;
  font-weight: 600;
}

.uc-proc-cpd__label {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .05em;
  background: #0400ff;
  color: #fff;
  border-radius: 3px;
  padding: 1px 4px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

.uc-proc-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  margin-left: 10px;
}

.uc-badge {
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 20px;
  text-transform: uppercase;
  white-space: nowrap;
}

.uc-badge--green {
  background: #d9fdd3;
  color: #0a5e2a;
}

.uc-badge--grey {
  background: #f0f2f5;
  color: #adb5bd;
}

.uc-tels {
  border-top: 1px solid #f0f2f5;
  background: #fafafa;
}

.uc-tel {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px 8px 18px;
  cursor: pointer;
  border-bottom: 1px solid #f0f2f5;
}

.uc-tel:last-child {
  border-bottom: none;
}

.uc-tel:hover {
  background: #f0fdf4;
}

.uc-tel--sel {
  background: #f6ffed;
}

.uc-tel--bloqueado {
  background: #fff8f8 !important;
  cursor: not-allowed;
  opacity: .75;
}

.uc-tel--semwpp {
  background: #fff7ed !important;
  cursor: not-allowed;
  opacity: .75;
}

.uc-chk {
  width: 18px;
  height: 18px;
  border-radius: 4px;
  flex-shrink: 0;
  border: 2px solid #d1d7db;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uc-chk--on {
  border-color: #25d366;
  background: #25d366;
}

.uc-chk--blocked {
  border-color: #fca5a5;
  background: #fca5a5;
}

.uc-tel-num {
  font-size: 13px;
  font-weight: 500;
  color: #111b21;
  font-family: monospace;
}

.uc-tel-tipo {
  font-size: 11px;
  color: #adb5bd;
  margin-left: 4px;
}

.uc-tel-dup {
  font-size: 11px;
  font-weight: 600;
  color: #fa8c16;
  margin-left: 4px;
}

.uc-tel-lgpd {
  font-size: 10px;
  font-weight: 600;
  color: #be123c;
  background: #ffe4e6;
  border-radius: 4px;
  padding: 1px 6px;
  margin-left: auto;
}

.uc-tel-semwpp {
  font-size: 10px;
  font-weight: 600;
  color: #c2410c;
  background: #fed7aa;
  border-radius: 4px;
  padding: 1px 6px;
  margin-left: auto;
}

.uc-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 0;
}

.uc-pg-btn {
  width: 30px;
  height: 30px;
  border: 1px solid #e9edef;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  font-size: 14px;
  color: #667781;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uc-pg-btn:hover:not(:disabled) {
  border-color: #00a884;
  color: #00a884;
}

.uc-pg-btn:disabled {
  opacity: .4;
  cursor: not-allowed;
}

.uc-pg-info {
  font-size: 13px;
  font-weight: 500;
  color: #111b21;
  padding: 0 8px;
}

.uc-spin {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, .4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: sp .7s linear infinite;
  display: inline-block;
}

.uc-spin--dark {
  border: 2px solid #d1d7db;
  border-top-color: #00a884;
}

.uc-swap-btn {
  margin-left: auto;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 12px;
  border-radius: 7px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #00a884;
  background: #fff;
  border: 1.5px solid #00a884;
  transition: background .15s, color .15s;
}

.uc-swap-btn:hover {
  background: #00a884;
  color: #fff;
}

.uc-modal-pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 16px;
  border-top: 1px solid #f0f2f5;
  flex-shrink: 0;
}

.uc-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.uc-modal {
  background: #fff;
  border-radius: 14px;
  width: 480px;
  max-width: 95vw;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 40px rgba(0, 0, 0, .18);
  overflow: hidden;
}

.uc-modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 18px;
  border-bottom: 1px solid #f0f2f5;
  background: #fff8f8;
  flex-shrink: 0;
}

.uc-modal-title {
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 14px;
  font-weight: 700;
  color: #be123c;
}

.uc-modal-close {
  width: 28px;
  height: 28px;
  border: 1px solid #fecdd3;
  border-radius: 6px;
  background: #fff;
  color: #be123c;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.uc-modal-close:hover {
  background: #ffe4e6;
}

.uc-modal-body {
  overflow-y: auto;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.uc-modal-item {
  border: 1px solid #fecdd3;
  border-radius: 8px;
  padding: 10px 14px;
  background: #fff8f8;
}

.uc-modal-item__nome {
  font-size: 13px;
  font-weight: 600;
  color: #be123c;
  margin-bottom: 4px;
}

.uc-modal-item__info {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-bottom: 6px;
}

.uc-modal-item__tels {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.uc-modal-tel {
  font-size: 12px;
  font-family: monospace;
  background: #ffe4e6;
  color: #be123c;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 600;
}

@keyframes sp {
  to {
    transform: rotate(360deg);
  }
}
</style>